import type {SortDescriptor} from "@project/design-system-web";
import type {SortingState} from "@tanstack/react-table";

/**
 * toSortDescriptor — converts a TanStack Table `SortingState` into a HeroUI
 * `SortDescriptor` for use with `Table.Content`'s `sortDescriptor` prop.
 *
 * Returns `undefined` when no sort is active (empty array), so the table
 * renders without a highlighted sort column.
 *
 * @example
 * ```ts
 * const sortDescriptor = toSortDescriptor(sorting);
 * // <Table.Content sortDescriptor={sortDescriptor} ... />
 * ```
 */
export function toSortDescriptor(sorting: SortingState): SortDescriptor | undefined {
  const firstSort = sorting[0];

  if (!firstSort) {
    return undefined;
  }

  return {
    column: firstSort.id,
    direction: firstSort.desc ? "descending" : "ascending",
  };
}
